<div class="site-header inline" *ngIf="Hidebar()">
  <app-header-topbar />

  <div
    class="flex search-group-bar align-items-center sticky top-0 z-5"
    #sticky_header_b2c
    id="sticky_header_b2c"
  >
    <div class="p-0">
      <div class="site-header__logo">
        <a [routerLink]="['/', 'inicio']">
          <img
            height="110"
            [src]="logoSrc"
            alt="logo-implementos"
            title="logo-implementos"
            class="lazyload"
          />
        </a>
      </div>
    </div>

    <div class="col p-0">
      <div class="site-header__middle">
        <div class="site-header__search">
          <app-header-search />
        </div>
      </div>
    </div>
  </div>

  <div
    class="header_nav"
    #sticky_header_b2c_nav
    id="sticky_header_b2c_nav"
  ></div>
</div>

<div class="site-header" *ngIf="!Hidebar()">
  <app-header-topbar [desde]="getDesde()" />
</div>
